import { render } from "./GiftComponent.vue?vue&type=template&id=04dbc437"
import script from "./GiftComponent.vue?vue&type=script&lang=js"
export * from "./GiftComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/devops/sourcecode/Sopecam/sopecam-cameroontribune-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__